import { Branding } from "@bcm-dev/bcms-vite";
import { TableBody, TableView } from "components/shared";
import React from "react";
import EntitlementsAccountsProfilesTableHeader, { AccountsProfilesTableHeaderItemView } from "../EntitlementsAccountsProfilesTableHeader";
import { EntitlementsProfileTableRow } from "../EntitlementsAccountsProfilesTableRow";

import "./styles.css";

/**
 * @function EntitlementsProfilesTable
 * @returns {React.Component}
 * @description The is the main Entitlements Profile table for Entitlements Page.
 */
export default function EntitlementsProfilesTable(props) {
    const profiles = props.profiles ?? [];
    const rows = profiles.reduce((acc, item) => {
        acc.push(
            <EntitlementsProfileTableRow key={ item.id } name={ item.name } profile={ item } dataPoint="Profile" />
        )
        return acc;
    }, []);

    return (
        <TableView className="entitlements-profiles-table">
            <EntitlementsAccountsProfilesTableHeader>
                <AccountsProfilesTableHeaderItemView className="header-col profile-col" text="Profiles" />
                <AccountsProfilesTableHeaderItemView className="skewed-col all-entitlements-col" text="All Entitlements" />
                <Branding id="rxp17_abi22" value="true">
                    <AccountsProfilesTableHeaderItemView className="skewed-col bill-pay-access-col" text="Bill Pay Access" />
                </Branding>
                <AccountsProfilesTableHeaderItemView className="skewed-col update-profile-col" text="Update Profile" />
                <Branding id="zle_abi22" value="true">
                    <AccountsProfilesTableHeaderItemView className="skewed-col update-profile-col" text="Zelle Access" />
                </Branding>
                <Branding id="tax_documents_abi22" value="true">
                    <AccountsProfilesTableHeaderItemView className="skewed-col update-profile-col" text="Tax Documents" />
                </Branding>
            </EntitlementsAccountsProfilesTableHeader>

            <TableBody>{ rows }</TableBody>
        </TableView>
    );
}
